const downloadBlobFile = (file: Blob, fileName: string) => {
  const blob = new Blob([file]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};

export default downloadBlobFile;
